import { render, staticRenderFns } from "./PreviewWidget.vue?vue&type=template&id=70d528e8&scoped=true&"
import script from "./PreviewWidget.vue?vue&type=script&lang=ts&"
export * from "./PreviewWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d528e8",
  null
  
)

export default component.exports